import { Theme } from "../../themes/theme";

export const inputStyles = `
  background: ${Theme.color.default.white};
  border: 1px solid #E8E4E0;
  border-radius: ${Theme.border.borderRadius.md};
  padding: 10px 14px;
  font-size: ${Theme.font.fontSize.sm};
  color: ${Theme.color.text.neutral};
  outline: none;
  width: 100%;
  box-shadow: none;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
  font-family: inherit;
  appearance: none;
  &::placeholder { color: #c8cad0; }
  &:focus { border-color: ${Theme.color.text.primary} }
`;
